import Vue from 'vue'
import Vuex from 'vuex'
import * as auth from '@/utils/auth.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: auth.getUser(),
    userInfo: auth.getUserInfo() || {}
  },
  mutations: {
    setUser (state, data) {
      // 修改state
      state.user = data
      // 将数据放到本地存储
      auth.setUser(state.user)
    },
    setUserInfo (state, data) {
      state.userInfo = data
      auth.setUserInfo(state.userInfo)
    }
  },
  actions: {
  },
  modules: {
  }
})
